export default {"src":"/_next/static/media/starKOL-active.7f67ffb7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};